const { Entity } = require('@octadesk/entity')
const RoleType = require('./role-type')
const PersonType = require('./person-type')
const PhoneContact = require('./phone-contact')
function parsePhoneContact(p) {
  try {
    return new PhoneContact(p)
  } catch (ex) {
    return p
  }
}
class Person extends Entity {
  constructor(document) {
    super(document)
    this.name = document.name
    this.email = document.email
    this.thumbUrl = document.thumbUrl
    this.type = parseInt(document.type) === PersonType.Employee ? PersonType.Employee : PersonType.Customer
    this.roleType = document.roleType || RoleType.agent
    this.customFields = document.customFields || []
    this.phoneContacts = document.phoneContacts ? document.phoneContacts.map(parsePhoneContact) : []
    this.organization = document.organization
    this.organizations = document.organizations || []
    this.products = document.products || []
    this.webPushSubscriptions = document.webPushSubscriptions || []
    this.guest = typeof document.guest === 'undefined' ? false : document.guest
  }
}

module.exports = Person
